export const STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_BLACK_AND_WHITE =
  "BLACK_AND_WHITE";
export const STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_COLOR = "COLOR";
export const STYLE_TRANSFER_INIT_IMAGE_INFLUENCE = [
  STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_BLACK_AND_WHITE,
  STYLE_TRANSFER_INIT_IMAGE_INFLUENCE_COLOR,
] as const;

export const initImageColorInfluenceLabelMapping: {
  [K in (typeof STYLE_TRANSFER_INIT_IMAGE_INFLUENCE)[number]]: string;
} = {
  BLACK_AND_WHITE: "Sketch",
  COLOR: "Picture",
};
